import api from './ApiService';

export interface InterestResponse {
  interests: Interest[] | null;
}

export interface Interest {
    id: string;
    name: string;
}

export async function index(): Promise<InterestResponse> {
  try {
    const response = await api.get('/interest');
    return response.data;
  } catch (error) {
    console.error('Erro ao carregar os interesses', error);
    throw new Error('Erro ao carregar os interesses');
  }
}
